/**
 * 北交所转板 代码变换 新三板提示
 */

import React,{useState, useEffect} from "react"
import { getBJCCodeTrans } from "../../../modules/quote/web"

export function BJSTip(props:{
  code: string
}){

  const [bjcode, SetBJCode] = useState('')

  const getData = async()=>{
    let bjcodereturn = await getBJCCodeTrans(props.code)
    console.info(props.code, bjcode)
    
    if(bjcodereturn){
      SetBJCode(bjcodereturn)
    }
  }

  useEffect(()=>{
    getData()
  }, [])

  if(bjcode){
    return (
      <div className="bjsquotetip">
        <a href={`/quote/stock/0.${bjcode}.html`}>公司于北交所转板上市，股票代码为{bjcode}</a>
      </div>
    )    
  }



  return <></>
}